import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { hasValue } from '@utils';
import { FontAwesomeIconWrapper } from "@icon/fontawesome/FontAwesomeIconWrapper";
import classNames from 'classnames';
/**
 * Show a simple loading animation indicator
 * @export
 */
const LoadingSpinner = (props) => {
    return _jsxs("div", { className: classNames("uxpcore_loadingspinner__container", props === null || props === void 0 ? void 0 : props.className), style: (props === null || props === void 0 ? void 0 : props.styles) || {}, children: [!(props === null || props === void 0 ? void 0 : props.spinnerOnly)
                ? _jsx("div", { className: "uxpcore_loadingspinner__message", children: hasValue(props === null || props === void 0 ? void 0 : props.message) ? props === null || props === void 0 ? void 0 : props.message : 'Loading...' })
                : null, _jsx("div", { className: "uxpcore_loadingspinner__spinner", children: _jsx(FontAwesomeIconWrapper, { icon: ['fas', 'spinner'], spin: true }) })] });
};
export default LoadingSpinner;
